<template>
  <!-- Welcome Drip Dashboard -->
  <div class="content-wrapper">
    <!-- AsideBar -->
    <!-- <AsideBar /> -->
    <!-- Content Header -->
    <div class="content-header">
      <div
        style="
          border-bottom: 1px solid #5c4a4a17;
          margin: auto !important;
          height: 75px;
        "
      >
        <div class="row mb-2">
          <div class="col-sm-12 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Welcome Drip</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Website' }"
                >Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'MainCont' }"
                >Website Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'MainDash' }"
                >Welcome Drip</router-link
              >
              <li class="breadcrumb-item active">Drips</li>
            </ol>
            <div class="button-group" style="right: 175px !important">
              <button
                class="btn btn-primary ml-3 mt-8 mb-1"
                style="border-radius: unset; background: #007bff"
                @click="
                  shwChangeLinkPopUp = !shwChangeLinkPopUp;
                  selectedDrips.length
                    ? null
                    : ((shwChangeLinkPopUp = false), (warningPopUp = true));
                "
              >
                Change Links
              </button>
            </div>
            <div class="button-group">
              <button
                class="btn btn-primary ml-3 mt-8 mb-1"
                style="border-radius: unset; background: #007bff"
                @click="showAdd = !showAdd"
              >
                <svg
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 16.3333C7.91683 16.3333 8.66683 15.5833 8.66683 14.6667H5.3335C5.3335 15.5833 6.07516 16.3333 7.00016 16.3333ZM12.0002 11.3333V7.16667C12.0002 4.60834 10.6335 2.46667 8.25016 1.9V1.33334C8.25016 0.641669 7.69183 0.0833359 7.00016 0.0833359C6.3085 0.0833359 5.75016 0.641669 5.75016 1.33334V1.9C3.3585 2.46667 2.00016 4.6 2.00016 7.16667V11.3333L0.333496 13V13.8333H13.6668V13L12.0002 11.3333Z"
                    fill="white"
                  />
                </svg>
                Add New Drip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Content -->
    <section class="content mt-3 pb-12">
      <div class="container" style="margin: 0 auto !important">
        <div class="row d-flex justify-content-center">
          <div class="col-12 pt-4">
            <v-data-table
              :items="drips"
              v-model="selectedDrips"
              show-select
              @toggle-select-all="selectAll"
              disable-sort
              :sort-desc="[false, false]"
            >
              <template v-slot:header>
                <span class="table-select-header"> Select All </span>
              </template>
              <template v-slot:item="{ item, index }">
                <tr
                  draggable
                  @dragstart="dragHandler($event, index)"
                  @dragover.prevent
                  @drop="dropHandler($event, index)"
                  class="table-data d-flex align-items-center mt-5"
                  style="border: none"
                >
                  <td
                    class="d-flex align-items-center border-unset"
                    style="width: 50px; margin-left: 4px; border: none"
                  >
                    <!-- <input
                      class="checkbox-welcome"
                      type="checkbox"
                      v-model="selectedDrips"
                      :value="item"
                      style="margin: 0px; padding: 0px; border: none"
                    /> -->
                    <v-checkbox
                      color="#5a6671"
                      v-model="selectedDrips"
                      :id="item.id.toString()"
                      :value="item"
                      multiple
                      style="margin: 16px 0 0 -3px"
                    ></v-checkbox>
                  </td>
                  <td
                    class="d-flex justify-content-between align-items-center border w-100"
                  >
                    <div>
                      <span class="drip-number mr-1">{{
                        item.drip_number
                      }}</span>
                      <span style="font-size: 11px" class="mr-4">
                        MESSAGE
                      </span>
                      <span style="font-size: 12px" class="font-weight-bold">
                        {{ item.title }}
                      </span>
                    </div>
                    <div>
                      <button class="mr-4">
                        <svg
                          class="edit-btn-svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          @click="id === item.id ? (id = '') : (id = item.id)"
                        >
                          <path
                            d="M0 15.25V19H3.75L14.81 7.94L11.06 4.19L0 15.25ZM17.71 5.04C18.1 4.65 18.1 4.02 17.71 3.63L15.37 1.29C14.98 0.899998 14.35 0.899998 13.96 1.29L12.13 3.12L15.88 6.87L17.71 5.04Z"
                            fill="#7F7F7F"
                          />
                        </svg>
                      </button>
                      <button>
                        <svg
                          class="del-btn-svg"
                          width="14"
                          height="18"
                          viewBox="0 0 14 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          @click="
                            shwQuestion = true;
                            group_id = item.group_id;
                            drip_id = item.id;
                          "
                        >
                          <path
                            d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z"
                            fill="#7F7F7F"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                <div
                  class="border"
                  style="margin: 0 0 0 54px !important"
                  v-if="id == item.id"
                >
                  <EditDrip @showSnackbar="showSnackbar" :id="item.id" />
                </div>
              </template>
            </v-data-table>
            <Spinner
              v-if="processLoading"
              class="loading-spinner--center"
              style="position: fixed !important"
            />
          </div>
        </div>
      </div>
      <!-- SnackBar -->
      <transition
        class="animate__faster"
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
      >
        <SuccessSnackbar
          v-if="success"
          @update-success="handleUpdateToSuccessSnackbar"
          message="Updated!"
        />
      </transition>
    </section>
    <!-- Adding PopUp -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <AddDrip v-if="showAdd" :length="drips.length" />
    </transition>
    <!-- Editing PopUp -->
    <!-- <Edit v-if="showEdit" :id="1556" /> -->
    <!-- Error PopUp -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Error v-if="error" :error="error" />
    </transition>

    <!-- Dialog For Changing Links -->
    <dialog-window
      v-if="selectedDrips.length && shwChangeLinkPopUp"
      @closeDialogOutside="shwChangeLinkPopUp = !shwChangeLinkPopUp"
      @confirmed="change($event)"
      placeholder="new link"
      :loading="processLoading"
    >
      <template #header> Change links </template>
      <template #disagreeBtnText> Cancel </template>
      <template #agreeBtnText> Change </template>
    </dialog-window>

    <!-- Warning Pop Up -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Warnings
        v-if="warningPopUp && !selectedDrips.length"
        @didClose="warningPopUp = false"
        warningText="Select drips!"
      />
    </transition>

    <!-- Questions Pop Up -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Question
        v-if="shwQuestion"
        @confirmed="deleteDrip(drip_id, group_id)"
        @notConfirmed="shwQuestion = false"
        @didClose="shwQuestion = false"
        title="Are you sure?"
        text="You wiil delete all selected welcome drips."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        isConfirmedTitle="Deleted"
        isConfirmedText="All selected welcome drips have been deleted!"
        dismissTitle="Cancelled"
        dismissText="All selected welcome drips are in safe :)"
        confirmButtonClasses="btn btn-danger"
        cancelButtonClasses="btn btn-success"
        successIcon="success"
        errorIcon="error"
      />
    </transition>
  </div>
</template>

<script>
import "../../../assets/styles/main.css";
import "animate.css";
import draggable from "vuedraggable";
import { mapState, mapGetters, mapActions } from "vuex";
//import { mapMultiRowFields } from "vuex-map-fields";
import Question from "../../popUps/Question.vue";
import AsideBar from "../../websiteDash/AsideBar.vue";
import AddDrip from "../../popUps/drip/welcome/AddDrip.vue";
import EditDrip from "../../popUps/drip/welcome/EditDrip.vue";
import Drip from "../../../apis/Drip.js";
//import Drip from "../../../apis/Drip.js";
import Error from "../../popUps/Error.vue";
import Warnings from "../../popUps/Warnings.vue";
import SuccessSnackbar from "../../popUps/SuccessSnackbar.vue";
import common from "../../../mixins/common";
import DialogWindow from "../../popUps/DialogWindow.vue";
import Spinner from "../../popUps/Spinner.vue";

export default {
  name: "WelcomeDash",
  mixins: [common],
  components: {
    AsideBar,
    AddDrip,
    EditDrip,
    Error,
    Warnings,
    SuccessSnackbar,
    Question,
    Spinner,
    DialogWindow,
    draggable,
  },
  data() {
    return {
      enabled: true,
      dragItem: "",
      dragging: false,
      processLoading: false,
      shwQuestion: false,
      warningPopUp: false,
      showEdit: true,
      showAdd: false,
      shwChangeLinkPopUp: false,
      dripInfo: "",
      success: false,
      id: "",
      drip_id: "",
      group_id: "",
      days: "",
      hours: "",
      mins: "",
      selectedDrips: [],
      headers: [{ value: "notification" }, { value: "edit" }],
    };
  },
  computed: {
    ...mapState({
      drips: (state) => state.welcomeDrip.drips,
      error: (state) => state.welcomeDrip.errorWelcomeDrip,
    }),
    ...mapGetters(["selectedDomain"]),
  },
  beforeMount() {
    this.$store.state.welcomeDrip.drips = [];
  },
  mounted() {
    if (
      typeof this.$route.params.edit_id === "number" ||
      typeof this.$route.params.edit_id === "string"
    ) {
      this.$store
        .dispatch(
          "getDrips",
          `?where[group_id]=${this.$route.params.edit_id}&where[domain_id]=${this.$route.params.id}&with[schedules]=*`
        )
        .then(() => {
          this.$store.state.welcomeDrip.drips = this.drips.sort(
            (a, b) => a.drip_number - b.drip_number
          );
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            (err.response.status === 501 || err.response.status === 500)
          ) {
            this.$router.push({ name: "MainDash" });
          }
        });
    }

    window.addEventListener("popstate", () => {
      this.$store.state.welcomeDrip.drips = [];
    });
  },
  methods: {
    ...mapActions([
      "deleteDrip",
      "deleteDripArray",
      "updateAllWelcomeDrips",
      "createOrUpdateWelcome",
      "getDrips",
      "getDripGroups",
    ]),
    dragHandler(event, index) {
      event.dataTransfer.effectAllowed = "copy";
      event.dataTransfer.setData("text/plain", index);
    },
    dropHandler(event, index) {
      event.preventDefault();

      const originalIndex = event.dataTransfer.getData("text/plain");
      const itemToMove = this.drips[originalIndex];
      this.$store.state.welcomeDrip.drips.splice(originalIndex, 1);
      this.$store.state.welcomeDrip.drips.splice(index, 0, itemToMove);

      this.$store.state.welcomeDrip.drips.forEach((drip, index) => {
        drip.drip_number = index;

        if (drip.schedules !== undefined) {
          drip.schedule = drip.schedules[0];
          delete drip.schedules;
        }
      });

      this.$store.state.welcomeDrip.drips = this.drips.sort(
        (a, b) => a.drip_number - b.drip_number
      );

      //console.log("🚀 ~ file: WelcomeDash.vue:412 ~ dropHandler ~ drips:", this.drips)

      this.updateAllWelcomeDrips(this.drips).then((response) => {
        //console.log("🚀 ~ file: WelcomeDash.vue:415 ~ this.updateAllWelcomeDrips ~ response:", response)
        this.success = true;

        setTimeout(() => {
          this.selectedDrips = [];
        }, 1000);
      });
    },
    objectIndex(drip_number) {
      let result = this.drips.findIndex((el) => el.drip_number === drip_number);
      return result;
    },
    selectAll() {
      if (this.selectedDrips.length < this.drips.length) {
        this.selectedDrips = this.drips;
        // Drip.get(
        //   "welcome",
        //   `?where[group_id]=${this.$route.params.edit_id}&where[domain_id]=${this.$route.params.id}&with[schedules]=*`
        // ).then((response) => {
        //   this.selectedDrips = response.data.data;
        // });
      } else if (this.selectedDrips.length === this.drips.length) {
        this.selectedDrips = [];
      }
    },
    deleteDrip(id, group_id) {
      if (this.selectedDrips.length) {
        let arrOfIds = this.selectedDrips.map(function (item) {
          return item["id"];
        });

        //arrOfIds = arrOfIds.toString().replace(/[\[\]']+/g, "");

        this.$store.dispatch("deleteDripArray", {
          domainId: this.$route.params.id,
          ids: arrOfIds,
        });
      } else if (!this.selectedDrips.length) {
        this.$store.dispatch("deleteDrip", {
          id: id,
          group_id: group_id,
        });
      }
    },
    showSnackbar(val) {
      this.success = val;
    },
    async change(event) {
      try {
        this.processLoading = true;

        if (event) {
          for (let i in this.selectedDrips) {
            this.selectedDrips[i].url = event;

            this.selectedDrips[i].schedule = this.checkField(
              this.selectedDrips[i].schedules,
              i
            );

            if (
              this.checkField(this.selectedDrips[i].schedules, i)[
                "frequency"
              ] !== undefined
            ) {
              delete this.selectedDrips[i].schedule.frequency;
            }

            if (this.selectedDrips[i].schedules !== undefined) {
              delete this.selectedDrips[i].schedules;
            }
          }

          await this.createOrUpdateWelcome({
            json: this.selectedDrips,
            withReplaceUrlButtons: true,
          })
            .then(async() => {
              // for (let i in this.$parent.selectedDrips) {
              //   this.$parent.selectedDrips[i].url = this.url;
              // }

              await this.getDrips(
                `?where[group_id]=${this.$route.params.edit_id}&where[domain_id]=${this.$route.params.id}&with[schedules]=*`
              );
            })
            .then(() => {
              this.successText =
                "The welcome links have been changed successfully!";
              this.success = true;

              setTimeout(() => {
                this.selectedDrips = [];
                this.shwChangeLinkPopUp = false;
              }, 1000);
            });
        } else {
          this.fireError = true;
        }
      } catch (e) {
        throw new Error(e);
      } finally {
        setTimeout(() => {
          this.processLoading = false;
        }, 1500);
      }
    },
    checkField(field, index) {
      if (field !== undefined) {
        return field[0];
      } else {
        return this.selectedDrips[index]["schedule"];
      }
    },
  },
  watch: {
    $route(to) {
      if (to.name == "MainDash") {
        this.getDripGroups({});
        this.$parent.shw = false;
      }
    },
  },
};
</script>

<style>
table.v-table tbody td {
  height: 40px;
  border: none !important;
}
.theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}
.checkbox-welcome {
  width: 24px !important;
  height: 30px !important;
}
.overlay-white {
  position: absolute;
  height: 100% !important;
  width: 100%;
  background: #ffffff;
  top: 0;
}
.table-select-header {
  font-size: 16px;
  font-weight: 500;
  color: #5b5a5a;
  position: absolute;
  top: 27px;
  left: 60px;
}
.drip-number {
  font-size: 11px;
  color: #ffffff;
  font-weight: 700;
  background: #3171b3;
  border-radius: 100%;
  padding: 4px 8px;
}
.v-data-footer {
  border-top: unset !important;
}
.table-data {
  border-radius: unset !important;
  height: 46px;
}
.word-break-all {
  word-break: break-all;
}
@media (max-width: 300px) {
  .bi-justify {
    margin-left: -13px;
  }
}
</style>
